import * as React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Grid, Typography } from '@upperhand/playmaker';

const AvatarWithTextContainer = ({ avatarName, primaryText, src, subText }) => (
  <Grid item container alignItems="center" spacing={2}>
    <Grid item>
      <Avatar size={74} src={src}>
        {!src && avatarName}
      </Avatar>
    </Grid>
    <Grid item>
      <Typography variant="h3" component="h3">
        {primaryText}
      </Typography>
      {subText && (
        <Typography variant="body1" component="p">
          {subText}
        </Typography>
      )}
    </Grid>
  </Grid>
);

AvatarWithTextContainer.defaultProps = {
  avatarName: '',
  src: '',
  subText: '',
};

AvatarWithTextContainer.propTypes = {
  avatarName: PropTypes.string,
  primaryText: PropTypes.string.isRequired,
  src: PropTypes.string,
  subText: PropTypes.string,
};

export default AvatarWithTextContainer;
